<template>
  <div>

    <div class="text-center" v-show="data.length > 1">
      <h2>{{ page_title }}</h2>
      <h4>Popular Gift Selection 2024</h4>
    </div>
    <div style="height: 600px;" v-if="data.length < 2">No data available.</div>
    <GChart v-else :type="chartType" :data="data" :options="chartOptions" />
  
    <hr />

    <div class="table-responsive p-2">
      <table
        :id="table_name"
        class="display table table-striped table-bordered"
        style="width:100%; text-align: center;"
      >
        <thead>
          <tr>
            <th>No.</th>
            <th>Gift</th>
            <th>Total</th>
            <th>Total Selected</th>
            <th>Total Redeemed</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in table_data" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.total }}</td>
            <td>{{ item.total_selected }}</td>
            <td>{{ item.total_redeemed }}</td>
            <td>
              <span @click="handleClick(item)">
                <router-link :to="goTo(item)" class="btn btn-primary btn-block rounded-4">View Details</router-link>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { GChart } from "vue-google-charts";

export default {
  components: {
    GChart
  },

  props: {
    chartOptions: {
      type: Object,
      required: false,
      default: {
        title: "Data",
        height: 600,
        legend: "bottom"
      }
    },

    chartType: {
      type: String,
      required: false,
      default: "ColumnChart"
    },

    data: {
      type: Array,
      required: false,
      default: []
    },

    table_name: {
      type: String,
      required: false,
      default: 'tbl_name'
    },

    table_data: {
      type: Array,
      required: false,
      default: []
    },

    page_title: {
      type: String,
      required: false,
      default: ''
    }
  },

  data() {
    return {
    };
  },

  methods: {
    goTo(item) {
      return `/marketing/gift/report/details/${item.id}`;
    },

    handleClick(item) {
      sessionStorage.setItem('gifts_name', item.name);
    }
  },

  async mounted() {
  }
};
</script>
